import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  static values = {
    keyAttribute: { type: String, default: "highlight" },
    selectedClass: { type: String, default: "is-selected" },
  };

  connect() {
    this.selected = new Set();
    this.paint();
  }

  toggle(event) {
    const key = this.keyFor(event.currentTarget);
    if (!key) return;

    if (this.selected.has(key)) {
      this.selected.delete(key);
    } else {
      this.selected.add(key);
    }

    this.paint();
  }

  clearAll(event) {
    if (event) event.preventDefault();

    this.selected.clear();
    this.paint();
  }

  paint() {
    const selectedClasses = this.selectedClassValue
      .split(/\s+/)
      .map((value) => value.trim())
      .filter(Boolean);

    this.itemTargets.forEach((el) => {
      const key = this.keyFor(el);
      const active = key ? this.selected.has(key) : false;

      selectedClasses.forEach((klass) => el.classList.toggle(klass, active));
      el.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  keyFor(element) {
    const datasetKey = this.keyAttributeValue;
    const raw = element.dataset[datasetKey];

    if (!raw) return null;

    return this.normalize(raw);
  }

  normalize(value) {
    return String(value || "")
      .replace(/^:/, "")
      .trim()
      .toLowerCase();
  }
}